<template>
  <div class="u-containar">
    <div class="swiper-container-wrapper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in items" :key="item.id">
            <MagazineCard
              :title="item.title"
              :category="item.category"
              :image="item.imageUrl"
              :imageAlt="item.imageAlt"
              :path="item.path"
              :membershipOnly="item.membershipOnly"
              :url="item.externalLinkUrl"
            />
          </div>
        </div>
      </div>
      <div
        class="swiper-pagination-container"
        :class="visibleClass(pagination)"
      >
        <div class="swiper-pagination" />
      </div>
      <div class="swiper-button-next" :class="visibleClass(navigation)" />
      <div class="swiper-button-prev" :class="visibleClass(navigation)" />
    </div>
  </div>
</template>

<script lang="ts">
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import { nextTick, onMounted, ref, watch, defineComponent, PropType } from 'vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import { MagazineSpecialRecommendContent } from '@/types/MagazineRecommend'

export default defineComponent({
  name: 'MagazineCardSlider',
  props: {
    items: {
      type: Array as PropType<MagazineSpecialRecommendContent[]>,
      default: () => []
    },
    navigation: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    pagination: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  components: {
    MagazineCard
  },
  setup(props) {
    const visibleClass = (arr: string[]) => ({
      hiddenPc: !arr.includes('pc'),
      hiddenSp: !arr.includes('sp')
    })
    const mySwiper = ref<any>(null)
    watch(
      () => props.items,
      () => {
        nextTick(() => {
          // 1画面で複数使うと配列になるっぽい
          if (Array.isArray(mySwiper.value)) {
            mySwiper.value.forEach((sw: any) => sw.update())
          } else {
            mySwiper.value.update()
          }
        })
      }
    )

    onMounted(() => {
      Swiper.use([Navigation, Pagination])
      mySwiper.value = new Swiper('.swiper-container', {
        breakpoints: {
          900: {
            slidesPerView: 4
          }
        },
        slidesPerView: 1.4,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    })
    return {
      visibleClass
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables'as var;

::v-deep(.swiper-pagination-bullet) {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid var.$color-main;
  background: var.$color-white;
  opacity: 1;
  margin: 0 auto auto;
}
::v-deep(.swiper-pagination-bullet-active) {
  background: var.$color-main;
}
.swiper-pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.swiper-pagination {
  display: flex;
  justify-content: space-between;
  width: 40%;
}

.swiper-button-next,
.swiper-button-prev {
  background-color: #fff;
  width: 50px;
  height: 50px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  position: absolute;
  transition: 0.2s;
  &:hover {
    background-color: #f5f5f5;
  }
  &::after {
    transform: scale(0.4);
  }
}
.swiper-button-next {
  top: 50%;
  right: -90px;
  transform: translate(-50%, 0);
}
.swiper-button-prev {
  top: 50%;
  left: -90px;
  transform: translate(50%, 0);
}
.swiper-container-wrapper {
  position: relative;
}
::v-deep(.swiper-button-next),
.swiper-button-prev {
  color: var.$color-main !important;
}
</style>
